








import { Component, Vue, Mixins, Watch, Prop } from 'vue-property-decorator';
import GlobalFnMixin from '@/util/mixins';
import R from '@/service/message';


@Component({
})
export default class MessageDetail extends Mixins(GlobalFnMixin) {
  @Prop()
  id!: any;

  content = '';
  loading = true;

  mounted() {
    this.init();
  }

  async init() {
    try {
      const {body} = await this.pendingRequest('loading', () => R.fetchMessageDetail(this.id));
      this.content = body;
    } catch (err) {
      this.$message.error(err.message);
    }
  }
}
